<template>
	<v-card class="mb-2 elevation-0">
		<v-col cols="12" class="px-4 py-1" @keyup.enter="cari()">
			<v-row>
				<v-col cols="12" md="4" v-for="(filter, index) in filterParams" :key="index">
					<template v-if="filter.type == 'text'">
						<v-text-field clearable outlined dense hide-details :label="filter.label" v-model="filter.filter.value"></v-text-field>
					</template>
					<template v-else-if="filter.type == 'number'">
						<v-text-field @keypress="onlyNumber" @paste="validatePaste($event, index)" clearable outlined dense hide-details :label="filter.label" v-model="filter.filter.value"></v-text-field>
					</template>
					<template v-else-if="filter.type == 'selection'">
						<v-autocomplete clearable outlined dense hide-details :items="filter.item" :item-text="filter.itemText" :item-value="filter.itemValue" :label="filter.label" v-model="filter.filter.value" class="width-0" no-data-text="Tidak ada data tersedia" @change="changeSelection(filter, filter.filter.value)"></v-autocomplete>
					</template>
					<template v-else-if="filter.type == 'date'">
						<v-menu v-model="filter.show" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field clearable outlined dense :value="convertDate(filter.filter.value)" :label="filter.label" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal" hide-details @click:clear="filter.filter.value = []"></v-text-field>
							</template>
							<v-date-picker locale="id" first-day-of-week="0" range color="primary" :max="today" v-model="filter.filter.value"></v-date-picker>
						</v-menu>
					</template>
				</v-col>
				<v-col cols="12" md="12" class="ma-0 pr-0 pl-0">
					<v-divider></v-divider>
				</v-col>
				<v-col cols="12" md="12" class="text-right">
					<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
					<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	computed: {
		...mapState(['filterParams'])
	},
	methods: {
		...mapMutations(['setSnackbar']),

		async validatePaste(val, index){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					// this.setSnackbar({
					// 	show: true,
					// 	color: 'red darken-2',
					// 	text: 'Tidak dapat meng copy data selain angka'
					// })
					this.filterParams[index].filter.value = ''
				}
			})
		},
		changeSelection(filter, val) {
			if (filter.function)
				filter.function(val)
		},
		resetFilter() {
			this.filterParams.forEach( el => {
				if (el.type == 'date')
					el.filter.value = []
				else
					el.filter.value = ''
			});
			this.$emit('onResetFilter')
		},
		cari() {
			let arr_filter = [...this.filterParams].map((el) => {
				let filter_obj = Object.assign({}, el.filter)
				if (el.type == 'date' && filter_obj.value != []) {
					filter_obj.value = filter_obj.value.sort().join('::')
				}
				return filter_obj
			})

			let filtered = arr_filter.filter(el => el.value !== null && el.value !== undefined && el.value !== '')
			this.$emit('searchFilter', filtered)
		}
	},
};
</script>